"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteInfo = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const constants_1 = require("../../common/util/constants");
const MapLink_1 = require("./MapLink");
const styles_1 = require("./styles");
const RouteInfo = ({ config, distance, location, searchedLocation, track }) => {
    var _a;
    const googleRoutesEnabled = ((_a = config.maps_config) === null || _a === void 0 ? void 0 : _a.google_routes) !== false;
    /**
      maps_config.google_routes defaults to true
      only if it is set to false do we want to suppress google routing
    */
    if (googleRoutesEnabled) {
        return (react_1.default.createElement(styles_1.LocationMapLinkContainer, null,
            react_1.default.createElement(MapLink_1.MapLink, { location: location, searchedLocation: searchedLocation, track: track, distance: distance })));
    }
    if (!googleRoutesEnabled && distance) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.Separator, { "aria-hidden": true }, "\u2022"),
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, constants_1.messages.locationDistance, { values: { distance } }))));
    }
    return null;
};
exports.RouteInfo = RouteInfo;
//# sourceMappingURL=RouteInfo.js.map